module.exports = __webpack_public_path__ + "static/media/info.fec0505e.svg";